import { Alert, AlertDescription, AlertIcon, AlertStatus, AlertTitle, Box } from '@arpeggi/ui'
import { FC, ReactElement, SVGProps } from 'react'

interface Props {
  title: string | ReactElement
  description?: string | ReactElement
  status?: AlertStatus
  icon?: FC<SVGProps<SVGSVGElement>>
}

export const ModalAlert: FC<Props> = ({ title, description, status = 'info', icon }) => {
  return (
    <Alert css={{ flexDirection: 'column', alignItems: 'flex-start' }} status={status}>
      <Box
        css={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',

          flexDirection: 'column',
          '@tablet': { flexDirection: 'row' }
        }}
      >
        <Box css={{ width: '28px' }}>
          <AlertIcon iconOverride={icon} />
        </Box>
        <AlertTitle
          css={{
            textAlign: 'center',
            margin: '8px 0',
            lineHeight: 'normal',
            '@tablet': { textAlign: 'left', margin: 0 }
          }}
        >
          {title}
        </AlertTitle>
      </Box>
      {description && (
        <AlertDescription
          css={{
            textAlign: 'center',
            '@tablet': { marginLeft: '28px', textAlign: 'left', marginTop: '4px', width: '100%' }
          }}
        >
          {description}
        </AlertDescription>
      )}
    </Alert>
  )
}
